import { render, staticRenderFns } from "./MomentosContablesList.vue?vue&type=template&id=a29dd080&scoped=true&"
import script from "./MomentosContablesList.vue?vue&type=script&lang=js&"
export * from "./MomentosContablesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29dd080",
  null
  
)

export default component.exports